import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../pages/AuthContext"; // Adjust path if necessary
import { getFirestore, collection, getDocs } from "firebase/firestore";
import FirebaseApp from "../config/Firebase";
import Header from "../components/Header";
import Footer from "../components/Footer";
import icon from "../assets/images/icon.png";

export default function Laram() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth(); // Consuming the global login method
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const db = getFirestore(FirebaseApp);

      // Replace "users" with your actual Firestore collection name
      const usersCollection = collection(db, "LDB"); 
      const querySnapshot = await getDocs(usersCollection);

      // Check if any document in the collection matches the username and password
      let isValidUser = false;

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.username === username && data.password === password) {
          isValidUser = true;
        }
      });

      if (isValidUser) {
        localStorage.setItem('currentUsername', username); // Store username for later use
        login(); // Set authenticated state to true
        navigate("/Middle"); // Redirect to the AddProduct page
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Error connecting to the database: " + err.message);
    }
  };

  return (
    <>
      <Header />
      <h1 className="text-2xl sm:text-4xl text-center Rubik-Bold text-black mt-4 sm:mt-8">
        LogIn to Aram EyeCare
      </h1>
      <p className="dancing unl-y text-center text-lg sm:text-2xl mt-2 sm:mt-4">
        Eye care that cares for you...
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center sm:h-screen px-4 sm:px-0">
        {/* Image Section */}
        <div className="sm:w-1/2 w-full flex items-center justify-center mb-6 sm:mb-0">
          <img
            src={icon}
            alt="login"
            className="rounded-lg shadow-md w-1/2 sm:max-w-[80%]"
          />
        </div>

        {/* Form Section */}
        <div className="sm:w-1/2 w-full flex items-center justify-center">
          <div className="w-full sm:w-3/4 max-w-md">
            <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-center">
              Login
            </h1>
            <form
              onSubmit={handleLogin}
              className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md"
            >
              <div className="mb-4 sm:mb-6">
                <label className="block text-base sm:text-lg font-medium mb-2">
                  Username:
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="w-full px-3 py-2 sm:px-4 sm:py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="mb-4 sm:mb-6">
                <label className="block text-base sm:text-lg font-medium mb-2">
                  Password:
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-3 py-2 sm:px-4 sm:py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              {error && (
                <p className="text-red-500 text-sm sm:text-base mb-4">
                  {error}
                </p>
              )}
              <button
                type="submit"
                className="w-full bg-black text-white py-2 sm:py-3 px-4 rounded-md hover:bg-gray-800 transition duration-200">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}